const baseRoute = [{
  path: '/',
  name: 'home',
  meta: {
    auth: false, // 是否登录状态下可访问
    keepAlive: false, // 是否缓存页面,
    pvCount:{
      source:'jyb-worker-team',
      module:'labour_team',
      moduleType:'',
    }
  },
  component: () => import('@/views/Home/Home.vue')
},
{
  path: '/home',
  name: 'Home',
  meta: {
    auth: false,
    keepAlive: false,
    pvCount:{
      source:'jyb-worker-team',
      module:'labour_team',
      moduleType:'',
    }
  },
  component: () => import('@/views/Home/Home.vue')
},
{
  path: '/helpCenter', // 帮助中心2
  name: 'HelpCenter',
  component: () =>
    import('@/views/HelpCenter/HelpCenter2.vue'),
  meta: {
    auth: false,
    keepAlive: true
  },
  children: [
    // 新手指南
    {
      path: '/content', // 注册账号
      name: 'Content',
      component: () =>
        import('@/views/HelpCenter/Content.vue'),
      meta: {
        auth: false,
        keepAlive: false
      }
    }
  ]
},

{
  path: '/construction', // 工程工队
  name: 'Construction',
  component: () => import('@/views/Construction/Construction.vue'),
  meta: {
    auth: false,
    keepAlive: true
  }
}, {
  path: '/constructionDetails/:id', // 工程工队详情
  name: 'ConstructionDetails',
  component: () => import('@/views/Construction/ConstructionDetails.vue'),
  meta: {
    auth: false,
    keepAlive: false
  }
},
 {
  path: '/rentInformationDetails', // 劳务公司信息详情
  name: 'RentInformationDetails',
  component: () => import('@/views/LabourService/RentInformationDetails/RentInformationDetails.vue'),
  meta: {
    auth: false,
    keepAlive: false
  }
}, {
  path: '/companyDetail', // 公司详情 (新)
  name: 'companyDetail',
  component: () => import('@/views/companyDetail/index.vue'),
  meta: {
    auth: false,
    keepAlive: false
  }
},


{
  path: '/searchResult', // 搜索页
  name: 'SearchResult2',
  component: () => import('@/views/Search/SearchResult.vue')
},

// 劳务用工
{
  path: '/labour',
  name: 'labour',
  component: () => import('@/views/Labor/Labor.vue'),
  meta: {
    auth: false,
    keepAlive: false,
    pvCount:{
      source:'jyb-worker-team',
      module:'labour_use_work',
      moduleType:'',
    }
  }
},
  {
    path: '/labourService', // 劳务公司信息列表
    name: 'LabourService',
    component: () => import('@/views/Labor/LaborDetail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      menu: "/labour",
      pvCount:{
        source:'jyb-worker-team-detail',
        module:'labour_use_work_info',
        moduleType:'no',
      }
    }
  },
{
  path: '/volunteerTeamOffer', // 工队报价
  name: 'VolunteerTeamOffer',
  component: () => import('@/views/VolunteerTeamOffer/VolunteerTeamOffer.vue'),
  meta: {
    auth: false,
    keepAlive: false,
    pvCount:{
      source:'jyb-worker-team',
      module:'work_quote',
      moduleType:'',
    }
  }
},
{
  path: '/volunteerTeamOfferDetails/:id', // 工队报价详情
  name: 'VolunteerTeamOfferDetails',
  component: () => import('@/views/VolunteerTeamOffer/VolunteerTeamOfferDetails.vue'),
  meta: {
    auth: false,
    keepAlive: false
  }
},
{
  path: '/worker', // 专业工人列表
  name: 'worker',
  component: () => import('@/views/worker/workerList.vue'),
  meta: {
    auth: false,
    keepAlive: false,
    pvCount:{
      source:'jyb-worker-team',
      module:'specialty_worker',
      moduleType:'',
    }
  }
},
{
  path: '/teamListWorkerDetail', // 工程工队板块专业工人详情
  name: 'workerDetail1',
  component: () => import('@/views/worker/workerDetail.vue'),
  meta: {
    auth: false,
    keepAlive: false,
    menu: "/teamList"
  }
},
{
  path: '/workerDetail', // 专业工人详情
  name: 'workerDetail2',
  component: () => import('@/views/worker/workerDetail.vue'),
  meta: {
    auth: false,
    keepAlive: false,
    menu: "/worker",
    pvCount:{
      source:'jyb-worker-team-detail',
      module:'worker_info',
      moduleType:'no',
    }
  }
},
{
  path: '/ForemanDetail/:id', // 班组长详情
  name: 'workerDetail3',
  component: () => import('@/views/worker/ForemanDetail.vue'),
  meta: {
    auth: false,
    keepAlive: false
  }
},



{
  path: '/RedesignDetailsPrise/:id/:no', // 工队报价详情
  name: 'RedesignDetailsPrise',
  component: () => import('@/views/RedesignTeamList/component/RedesignDetailsPrise.vue'),
  meta: {
    auth: false,
    keepAlive: false
  }
},

{
  path: '/teamList', // 施工工队列表
  name: 'TeamList',
  meta: {
    pvCount:{
      source:'jyb-worker-team',
      module:'eng_team',
      moduleType:'',
    }
  },
  component: () => import('@/views/RedesignTeamList/RedesignTeamList.vue')
},
{
  path: '/teamDetails/:id', // 施工工队详情
  name: 'RedesignTeamDetails',
  component: () => import('@/views/RedesignTeamList/component/RedesignTeamDetails.vue'),
  meta: {
    auth: false,
    keepAlive: false
  }
},

{
  path: '/detail',
  name: 'Detail',
  meta: {
    auth: false,
    keepAlive: false
  },
  component: () => import('@/views/RedesignTeamList/component/buildDetails.vue')
},
{
  path: '/RedesignTeamDetailsEqu', // 设备详情
  name: 'RedesignTeamDetailsEqu',
  component: () => import('@/views/RedesignTeamList/component/RedesignTeamDetailsEqu.vue'),
  meta: {
    auth: false,
    keepAlive: false
  }
},
{
  path: '/RedesignTeamDetailsReslut', // 业绩详情
  name: 'RedesignTeamDetailsReslut',
  component: () => import('@/views/RedesignTeamList/component/RedesignTeamDetailsReslut.vue'),
  meta: {
    auth: false,
    keepAlive: false
  }
},
{
  path: '/RedesignTeamDetailsPrise', // 报价详情
  name: 'RedesignTeamDetailsPrise',
  component: () => import('@/views/RedesignTeamList/component/RedesignTeamDetailsPrise.vue'),
  meta: {
    auth: false,
    keepAlive: false
  }
},

{
  path: '/teamYJDetail', // 业绩详情-企业
  name: 'teamYJDetail',
  component: () => import('@/views/VolunteerTeamOffer/teamYJDetail.vue'),
  meta: {
    auth: false,
    keepAlive: false
  }
},
{
  path: '/teamOfferDetail', // 报价详情-企业
  name: 'teamOfferDetail',
  component: () => import('@/views/VolunteerTeamOffer/teamOfferDetail.vue'),
  meta: {
    auth: false,
    keepAlive: false,
    menu: "/volunteerTeamOffer",
    pvCount:{
      source:'jyb-worker-team-detail',
      module:'work_type_info',
      moduleType:'pNo',
    }
  }
},
{
  path: '/teamRYDetail', // 人员详情-企业
  name: 'teamRYDetail',
  component: () => import('@/views/VolunteerTeamOffer/teamRYDetail.vue'),
  meta: {
    auth: false,
    keepAlive: false
  }
},
{
  path: '/teamSHBDetail', // 设备详情-企业
  name: 'teamSHBDetail',
  component: () => import('@/views/VolunteerTeamOffer/teamSHBDetail.vue'),
  meta: {
    auth: false,
    keepAlive: false
  }
},

{
  path: '/IndividualTeamYJDetail', // 业绩详情-个人
  name: 'IndividualTeamYJDetail',
  component: () => import('@/views/IndividualPage/IndividualTeamYJDetail.vue'),
  meta: {
    auth: false,
    keepAlive: false
  }
},
{
  path: '/IndividualTeamOfferDetail', // 报价详情-个人
  name: 'IndividualTeamOfferDetail',
  component: () => import('@/views/IndividualPage/IndividualTeamOfferDetail.vue'),
  meta: {
    auth: false,
    keepAlive: false,
    menu: "/volunteerTeamOffer"
  }
},
{
  path: '/IndividualTeamRYDetail', // 人员详情-个人
  name: 'IndividualTeamRYDetail',
  component: () => import('@/views/IndividualPage/IndividualTeamRYDetail.vue'),
  meta: {
    auth: false,
    keepAlive: false
  }
},
{
  path: '/IndividualTeamSHBDetail', // 设备详情-个人
  name: 'IndividualTeamSHBDetail',
  component: () => import('@/views/IndividualPage/IndividualTeamSHBDetail.vue'),
  meta: {
    auth: false,
    keepAlive: false
  }
},

{
  path: '/LaborServiceCompany', // 劳务公司列表
  name: 'LaborServiceCompany',
  // component: () => import('@/views/LaborServiceCompany/LaborServiceCompany.vue'),
  component: () => import('@/views/LaborServiceCompany/LaborTeamList.vue'),
  meta: {
    auth: false,
    keepAlive: false,
    pvCount:{
      source:'jyb-worker-team',
      module:'labour_com',
      moduleType:'',
    }
  }
},
{
  path: '/popularityTeam', // 人气工队列表
  name: 'popularityTeam',
  component: () => import('@/views/popularityTeam/popularityTeam.vue'),
  meta: {
    auth: false,
    keepAlive: false,
    pvCount:{
      source:'jyb-worker-team',
      module:'moods_team',
      moduleType:'',
    }
  }
},

{
  path: '/FlexibleEmployment', // 临时用工列表
  name: 'FlexibleEmployment',
  component: () => import('@/views/FlexibleEmployment/FlexibleEmployment.vue'),
  meta: {
    auth: false,
    keepAlive: false,
    pvCount:{
      source:'jyb-worker-team',
      module:'floater_use_work',
      moduleType:'',
    }
  }
},
{
  path: '/FlexibleDetail', // 临时用工详情
  name: 'FlexibleDetail',
  component: () => import('@/views/FlexibleEmployment/FlexibleDetail.vue'),
  meta: {
    auth: false,
    keepAlive: false,
    menu: "/FlexibleEmployment",
    pvCount:{
      source:'jyb-worker-team-detail',
      module:'labour_floater_info',
      moduleType:'no',
    }
  }
},
{
  path: '/signUp', // 灵活用工-立即报名
  name: 'signUp',
  component: () => import('@/views/FlexibleEmployment/signUp.vue'),
  meta: {
    auth: false,
    keepAlive: false,
    menu: "/FlexibleEmployment"
  }
},
{
  path: '/ConstructionTeamDetail', // 施工队详情页
  name: 'ConstructionTeamDetail',
  component: () => import('@/views/ConstructionTeamDetail/ConstructionTeamDetail.vue'),
  meta: {
    auth: false,
    keepAlive: false,
    menu: "/teamList",
    pvCount:{
      source:'jyb-worker-team-detail',
      module:'team_info',
      moduleType:'teamNo',
    }
  }
},
{
  path: '/popularityTeamDetail', // 施工队详情页
  name: 'popularityTeamDetail',
  component: () => import('@/views/ConstructionTeamDetail/ConstructionTeamDetail.vue'),
  meta: {
    auth: false,
    keepAlive: false,
    menu: "/popularityTeam",
    pvCount:{
      source:'jyb-worker-team-detail',
      module:'team_info',
      moduleType:'teamNo',
    }
  }
},
  {
    path: '/record', // 班组记工、个人记工
    name: 'record',
    component: () => import('@/views/record/index.vue'),
    meta: {
      auth: false,
      keepAlive: false
    },
  },
  {
    path: '/IndividualRecord', // 个人记账
    name: 'individualrecord',
    component: () => import('@/views/IndividualRecord/IndividualRecord'),
    meta: {
      auth: false,
      keepAlive: false,
    }
  },
  {
    path: '/TeamRecord', // 班组记账
    name: 'teamRecord',
    component: () => import('@/views/TeamRecord/TeamRecord'),
    meta: {
      auth: false,
      keepAlive: false,
    }
  },
  {
    // 招标大厅
    path: "/zb",
    name: "zb",
    icon: "zc-home4.png",
    meta: {
      auth: false,
      keepAlive: false,
      isMenu: true,
      Title: "招标大厅"
    },
    // component: DTBaseRouter,
    component: () => import("@/views/tenderHall/index")
  },
  {
    path: '/TeamSearchJobDetail', // 班组找活详情页
    name: 'TeamSearchJobDetail',
    component: () => import('@/views/TeamSearchJob/TeamSearchJobDetail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      menu: "/teamList",
    }
  },
]
export default baseRoute
